import { useContext } from 'react';

import { SelectionOriginContext } from './SelectionOriginContext';

const useSelectionOrigin = () => useContext(SelectionOriginContext);

export default useSelectionOrigin;
